module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2qR6r"))).then(() => parcelRequire('ikE14'));